import * as React from "react";
import { Component } from "react";
import { Redirect } from "react-router";
import LoadingStatus from "src/components/common/LoadingStatus";
import CompanyForm from "src/components/projects/project/accounts/CompanyForm";
import fs from "src/services/config/fbConfig";
import { ICompany, ICompanyPageProps, ICompanyPageState } from "./interfaces";

export default class CompanyPage extends Component<ICompanyPageProps, ICompanyPageState> {
  private projectDocument: firebase.firestore.DocumentReference;
  public constructor(props: ICompanyPageProps) {
    super(props);

    this.state = {
      loading: true,
      saving: false,
      name: "",
      address: "",
      cityState: "",
      email: "",
      phone: "",
      fax: "",
      website: "",
    };

    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.handleNameChanged = this.handleNameChanged.bind(this);
    this.handleAddressChanged = this.handleAddressChanged.bind(this);
    this.handleCityStateChanged = this.handleCityStateChanged.bind(this);
    this.handleEmailChanged = this.handleEmailChanged.bind(this);
    this.handlePhoneChanged = this.handlePhoneChanged.bind(this);
    this.handleFaxChanged = this.handleFaxChanged.bind(this);
    this.handleWebsiteChanged = this.handleWebsiteChanged.bind(this);
  }

  public componentWillMount() {
    this.projectDocument = fs.fs.collection("projects").doc(this.props.match.params.id);
  }

  public componentDidMount() {
    this.projectDocument
      .get()
      .then(doc => {
        if (doc.exists) {
          if (this.props.companyType === 0) {
            const { supplyCompany } = doc.data() as any;
            if (supplyCompany) {
              this.setState({
                name: supplyCompany.name ? supplyCompany.name : "",
                address: supplyCompany.address ? supplyCompany.address : "",
                cityState: supplyCompany.cityState ? supplyCompany.cityState : "",
                email: supplyCompany.email ? supplyCompany.email : "",
                phone: supplyCompany.phone ? supplyCompany.phone : "",
                fax: supplyCompany.fax ? supplyCompany.fax : "",
                website: supplyCompany.website ? supplyCompany.website : "",
              });
            } else {
              this.setState({
                name: "",
                address: "",
                cityState: "",
                email: "",
                phone: "",
                fax: "",
                website: "",
              });
            }
          } else if (this.props.companyType === 1) {
            const { deliveryCompany } = doc.data() as any;
            if (deliveryCompany) {
              this.setState({
                name: deliveryCompany.name ? deliveryCompany.name : "",
                address: deliveryCompany.address ? deliveryCompany.address : "",
                cityState: deliveryCompany.cityState ? deliveryCompany.cityState : "",
                email: deliveryCompany.email ? deliveryCompany.email : "",
                phone: deliveryCompany.phone ? deliveryCompany.phone : "",
                fax: deliveryCompany.fax ? deliveryCompany.fax : "",
                website: deliveryCompany.website ? deliveryCompany.website : "",
              });
            } else {
              this.setState({
                name: "",
                address: "",
                cityState: "",
                email: "",
                phone: "",
                fax: "",
                website: "",
              });
            }
          }
        }
      })
      .then(() => {
        this.setState({ loading: false });
      });
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus type="Ball-Triangle" />;
    }
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="flex-column container">
        <CompanyForm
          name={this.state.name}
          address={this.state.address}
          cityState={this.state.cityState}
          email={this.state.email}
          phone={this.state.phone}
          fax={this.state.fax}
          website={this.state.website}
          handleNameChanged={this.handleNameChanged}
          handleAddressChanged={this.handleAddressChanged}
          handleCityStateChanged={this.handleCityStateChanged}
          handleEmailChanged={this.handleEmailChanged}
          handlePhoneChanged={this.handlePhoneChanged}
          handleFaxChanged={this.handleFaxChanged}
          handleWebsiteChanged={this.handleWebsiteChanged}
          appService={this.props.appService}
          history={this.props.history}
          match={this.props.match}
          handleSave={this.handleSave}
          handleCancel={this.handleCancel}
        />
      </div>
    );
  }

  private handleSave() {
    const company: ICompany = {
      name: this.state.name,
      address: this.state.address,
      cityState: this.state.cityState,
      email: this.state.email,
      phone: this.state.phone,
      fax: this.state.fax,
      website: this.state.website,
    };
    if (this.props.companyType === 0) {
      this.projectDocument
        .update({
          supplyCompany: company,
        })
        .then(() => {
          this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
        });
    } else if (this.props.companyType === 1) {
      this.projectDocument
        .update({
          deliveryCompany: company,
        })
        .then(() => {
          this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
        });
    }
  }
  private handleCancel() {
    this.props.history.push(`/project/${this.props.appService.getActiveProjectId()}`);
  }
  private handleNameChanged(value: string) {
    this.setState({ name: value });
  }
  private handleAddressChanged(value: string) {
    this.setState({ address: value });
  }
  private handleCityStateChanged(value: string) {
    this.setState({ cityState: value });
  }
  private handleEmailChanged(value: string) {
    this.setState({ email: value });
  }
  private handlePhoneChanged(value: string) {
    this.setState({ phone: value });
  }
  private handleFaxChanged(value: string) {
    this.setState({ fax: value });
  }
  private handleWebsiteChanged(value: string) {
    this.setState({ website: value });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/accounts/CompanyPage.tsx